module.exports = __webpack_public_path__ + "img/bg-grey-scratch.de09f394.png";